import { Button } from "@heroui-v3/react";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { LimeAiSparkleIcon } from "@/Components/NextBase/LimeAiButton";
import { useOptionalAiChat } from "./ai-chat-context";
import { useHasAiChatAccess } from "./useHasAiChatAccess";
import { AI_CHAT_PANEL_ID } from "./types";

type Props = { onOpened: () => void };

export function AiChatToggle({ onOpened }: Props) {
  const hasAccess = useHasAiChatAccess();
  const aiChat = useOptionalAiChat();

  if (!hasAccess || !aiChat) {
    return null;
  }
  const { isOpen, open } = aiChat;

  return (
    <Button
      variant="ghost"
      size="sm"
      className="h-9 w-full justify-start px-2 text-foreground-700"
      aria-expanded={isOpen}
      aria-controls={AI_CHAT_PANEL_ID}
      aria-label={t`Lime AI`}
      data-identifier="ai-chat-toggle"
      onPress={() => {
        open();
        onOpened();
      }}
    >
      <LimeAiSparkleIcon size={16} className="shrink-0" />
      <Trans>Lime AI</Trans>
    </Button>
  );
}
